<div
  class="laureate-icon-png"
  [matTooltip]="  'copy-title' | translate "
  (click)="clickCopy()"
  [cdkCopyToClipboard]="value"
  [matTooltipClass]="'mat-tooltip-not-break'"
>
  <img  src="assets/img/icons/icon_copy.png" alt="icon_copy" />
</div>
